var exports = {
  "x": "TextPlaceholder__8V8E4Z",
};

module.exports = exports;
